<template>
  <div>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'authentication-layout',
  };
</script>

<style lang="scss" scoped>

</style>
